import { useCallback } from 'react'
import { useRecoilValue } from 'recoil'
import { myLanguageState } from '~/features/i18n/store'
import { getLanguage } from '~/libs/language'
import * as GA from './ga'

export type ShareItemType = 'url' | 'x' | 'facebook'

interface ShareModalViewModal {
  onClickShareItem: (itemType: ShareItemType) => void
}

interface ShareModalViewModalProps {
  previewVideoId: string
  title: string
  description: string
}

export function useShareModalViewModal({
  previewVideoId,
  title,
  description,
}: ShareModalViewModalProps): ShareModalViewModal {
  const myLanguage = useRecoilValue(myLanguageState)

  const onClickShareItem = useCallback(
    (item: ShareItemType) => {
      GA.shareItemClick(Number(previewVideoId))
      let url: string
      if (getLanguage(window.location.hostname) || myLanguage === undefined) {
        url = `${window.location.origin}/videos/${previewVideoId}`
      } else {
        const { protocol, hostname, port } = window.location
        const parts = hostname.split('.')
        if (parts[0] === 'www') {
          parts[0] = myLanguage
        } else {
          parts.unshift(myLanguage)
        }
        console.log(parts)

        url = `${protocol}//${parts.join('.')}${port ? `:${port}` : ''}/videos/${previewVideoId}`
      }

      switch (item) {
        case 'url':
          navigator.clipboard.writeText(url)
          break
        case 'x':
          window.open(
            `https://x.com/intent/tweet?url=${url}%0a&text=${title}%0a${description}%0a&hashtags=samansa`,
            '_blank',
          )
          break
        case 'facebook':
          window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank')
          break
      }
    },
    [description, previewVideoId, title, myLanguage],
  )

  return { onClickShareItem }
}
